import React, { useCallback, useEffect, useRef } from 'react';
import EditRoutine from './EditRoutine';

import type {
  TrainingRoutine,
  TrainingRoutineTemplate,
  WithOptionalId,
} from '../../types';

export interface EditRoutineTemplateDialogProps {
  onSubmit: (
    template: WithOptionalId<TrainingRoutineTemplate>,
  ) => Promise<boolean>;
  template: WithOptionalId<TrainingRoutineTemplate>;
  setTemplate: React.Dispatch<
    React.SetStateAction<WithOptionalId<TrainingRoutineTemplate>>
  >;
  onClose: () => void;
  isNew?: boolean;
}

const EditRoutineTemplate: React.FC<EditRoutineTemplateDialogProps> = ({
  onClose,
  onSubmit,
  template,
  setTemplate,
  isNew = false,
}) => {
  const templateRef = useRef(template);
  useEffect(() => {
    templateRef.current = template;
  }, [template]);

  const handleSubmitRoutine = useCallback(
    async (routine: TrainingRoutine): Promise<boolean> => {
      const mergedTemplate = {
        ...templateRef.current,
        name: routine.name,
        routine,
      };
      return await onSubmit(mergedTemplate);
    },
    [onSubmit],
  );

  const setRoutine = useCallback(
    (updater: React.SetStateAction<TrainingRoutine>) => {
      setTemplate((prev) => {
        const nextRoutine =
          typeof updater === 'function'
            ? (updater as any)(prev.routine)
            : updater;
        return { ...prev, routine: nextRoutine, name: nextRoutine.name };
      });
    },
    [setTemplate],
  );

  return (
    <EditRoutine
      onSubmit={handleSubmitRoutine}
      routine={template.routine}
      setRoutine={setRoutine}
      onClose={onClose}
      isNew={isNew}
    />
  );
};

export default EditRoutineTemplate;
